
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppFormRow, AppSelect, AppButton } from '@/components';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { useAvatarDefaultList } from '@/modules/avatar/default/model/list';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { AvatarGender } from '@/modules/avatar/gender/model/gender';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.DEFAULT.INDEX,
    components: { AppTable, AppCard, AppFormRow, AppSelect, AppButton },
    setup() {
        const { query, list, total, fetchList, actions } = useAvatarDefaultList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: AvatarDefaultType },
                { type: TableColumnType.Option, label: 'Gender', key: 'gender', options: AvatarGender },
                { type: TableColumnType.Image, label: 'Image', imageKey: 'image', statusKey: 'imageStatus' },
                { type: TableColumnType.Boolean, label: 'Is published', key: 'isPublished' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_AVATAR.DEFAULT.EDIT, params: { avatarId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Firstname(s)',
                        to: { name: ROUTE_NAME_AVATAR.DEFAULT.TRANSLATE, params: { avatarId: row.id } }
                    }),
                    canShow: (row: any) => row.canTranslate,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { query, table, list, total, fetchList, actions, AvatarDefaultType, ROUTE_NAME_AVATAR };
    }
});

const AvatarDefaultType = [
    { label: 'All', value: '', background: 'info' },
    { label: 'Bot', value: '1', background: 'info' },
    { label: 'Admin', value: '2', background: 'info' },
    { label: 'DefaultAvatar', value: '3', background: 'info' },
    { label: 'FakePlayer', value: '4', background: 'info' }
];
